import { SchemaMarkupField } from '@formily/react-schema-renderer';
export var Field = SchemaMarkupField;
